export default __webpack_public_path__ + "static/media/11.cbae7e79.png";